import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FormBody from '_components/formBody'

import styles from './styles.css'

export default class NoteForm extends Component {
  static propTypes = {
    noteData: PropTypes.object,
    toUser: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onArchive: PropTypes.func.isRequired,
  }

  static defaultProps = {
    noteData: {},
  }

  state = {
    isUpdateNote: false,
    isResolvedNote: false,
    subject: '',
    urgencyType: '',
    preferredResponse: '',
    message: '',
  }

  componentWillMount() {
    const { noteData } = this.props
    if (Object.keys(noteData).length !== 0) {
      const { subject, urgencyType, preferredResponse, message } = this.props.noteData

      this.setState({
        subject,
        urgencyType,
        preferredResponse,
        message,
        isUpdateNote: noteData.noteStatus <= 2,
        isResolvedNote: noteData.noteStatus === 3,
      })
    }
  }

  onInputChange = e => {
    const { id, value } = e.target
    this.setState({ [id]: value })
  }

  onUpdate = () => {
    const { onUpdate, onCancel, toUser, noteData } = this.props
    const { subject, urgencyType, preferredResponse, message } = this.state
    const payload = {
      noteId: noteData._id,
      toUser,
      subject,
      urgencyType,
      preferredResponse,
      message,
      noteStatus: 1,
    }
    onUpdate(payload)
    onCancel()
  }

  onDelete = () => {
    const { onDelete, onCancel, noteData } = this.props
    onDelete(noteData._id)
    onCancel()
  }

  onArchive = () => {
    const { onArchive, onCancel, noteData } = this.props
    onArchive(noteData._id)
    onCancel()
  }

  onSend = () => {
    const { onSend, onCancel, toUser } = this.props
    const { subject, urgencyType, preferredResponse, message } = this.state
    const payload = { toUser, subject, urgencyType, preferredResponse, message }
    onSend(payload)
    onCancel()
  }

  onCancel = () => {
    const { onCancel } = this.props
    onCancel()
  }

  render() {
    const {
      subject,
      urgencyType,
      preferredResponse,
      message,
      isUpdateNote,
      isResolvedNote,
    } = this.state
    const buttons = isResolvedNote
      ? [
          { label: 'Update', onClick: this.onUpdate },
          { label: 'Archive', onClick: this.onArchive },
          { label: 'Delete', onClick: this.onDelete },
          { label: 'Cancel', onClick: this.onCancel },
        ]
      : isUpdateNote
      ? [
          { label: 'Update', onClick: this.onUpdate },
          { label: 'Delete', onClick: this.onDelete },
          { label: 'Cancel', onClick: this.onCancel },
        ]
      : [{ label: 'Send', onClick: this.onSend }, { label: 'Cancel', onClick: this.onCancel }]
    return (
      <FormBody buttons={buttons} style={{ padding: '0 20px' }}>
        <input
          id="subject"
          type="text"
          placeholder="Subject"
          className={styles.formInput}
          value={subject}
          onChange={this.onInputChange}
        />
        <input
          id="urgencyType"
          type="text"
          placeholder="Urgency"
          className={styles.formInput}
          value={urgencyType}
          onChange={this.onInputChange}
        />
        <input
          id="preferredResponse"
          type="text"
          placeholder="Preferred Reply Method"
          className={styles.formInput}
          value={preferredResponse}
          onChange={this.onInputChange}
        />
        <textarea
          id="message"
          placeholder="Message"
          rows={5}
          value={message}
          onChange={this.onInputChange}
          className={styles.formTextArea}
          onKeyPress={this.onKeyPress}
        />
      </FormBody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/collaborate/sent-message-panel/note-form/index.js